module.exports = __webpack_public_path__ + "static/media/pic6.3fee8d5f.jpg";